import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ComponentFactoryResolver } from "@angular/core";
import { Principal } from '../../../services/auth/principal.service';
import { UaaResourceService } from "../../../services/service/uaa-resource.service";
import { CoreConfigService } from "../../../services/config/core-config.service";
import { NavMenu, NavMenuItem } from '../../model/nav-menu';
import { Router } from '@angular/router';

@Component({
  selector: "zx-header-nav-menu",
  templateUrl: "header-nav-menu.component.html",
  styleUrls: ['./header-nav-menu.component.css']
})
export class HeaderNavMenuComponent implements OnInit {
  private _currentApp: any;
  private _currentNav: any = {};
  @Output() navMenuChanged: EventEmitter<any> = new EventEmitter();
  navMenu: any = [];
  rightNavMenu: any = [];
  private _navRoot;

  constructor(
    private principal: Principal,
    private resourceService: UaaResourceService,
    private configService: CoreConfigService,
    private router: Router
  ) {}

  ngOnInit() {
  }

  private initNavBar(){
    if(!this._currentApp) return;

    let leftNavMenu = [];
    let rightNavMenu = [];
    this.resourceService.getMyNavTree(this.currentApp.id).then(navMenu => {
      let menuRoot = new NavMenu({data:navMenu});
      let menuItems = menuRoot.items;
      if (menuItems.length > 0) {
        for (let i = 0; i < menuItems.length; i++) {
          if (this.configService.rightNavMenu && this.configService.rightNavMenu.includes(navMenu.children[i]["name"])) {
            rightNavMenu.push(menuItems[i])
          } else {
            leftNavMenu.push(menuItems[i])
          }
        }
      }
      this.currentNav = leftNavMenu.length>0?leftNavMenu[0]:null;
      this.navMenu = leftNavMenu;
      this.rightNavMenu = rightNavMenu;
    });
  }

  @Input() set currentApp(app:any){
    if(this._currentApp == app) return;

    this._currentApp = app;
    this.initNavBar()
  }
  get currentApp(){
    return this._currentApp;
  }

  set currentNav(nav:any){
    if(this._currentNav == nav) return;
    this._currentNav = nav;
    this.navMenuChanged.emit(nav);
  }
  get currentNav(){
    return this._currentNav;
  }

  hasPermission(menuItem:NavMenuItem):boolean{
    return this.principal.hasAnyAuthority(menuItem.data.authorities);
  }

  loadLeftNavMenu(navItem) {
    this.currentNav = navItem;
  }
}
